import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Utensils, Calendar, Dumbbell, User } from "lucide-react";
import { motion } from "framer-motion";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: "dashboard", label: "Home", icon: Home, path: "/dashboard" },
    { id: "food", label: "Food", icon: Utensils, path: "/food" },
    { id: "diet", label: "Diet", icon: Calendar, path: "/diet" },
    { id: "workout", label: "Workout", icon: Dumbbell, path: "/workout" },
    { id: "profile", label: "Profile", icon: User, path: "/profile" },
  ];

  const handleNavClick = (item) => {
    // ✅ Prevent re-navigation to same path (avoids loops)
    if (location.pathname !== item.path) {
      navigate(item.path);
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <motion.button
              key={item.id}
              onClick={() => handleNavClick(item)}
              className="flex flex-col items-center justify-center space-y-1 relative"
              whileTap={{ scale: 0.95 }}
            >
              {/* Active background */}
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute inset-0 bg-emerald-100"
                  initial={false}
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}

              <Icon
                className={`w-5 h-5 relative z-10 ${
                  isActive ? "text-emerald-600" : "text-gray-400"
                }`}
              />

              <span
                className={`text-xs relative z-10 ${
                  isActive
                    ? "text-emerald-600 font-medium"
                    : "text-gray-500"
                }`}
              >
                {item.label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
